var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43231 1.65449C6.49166 0.595138 7.92845 0 9.4266 0C10.9247 0 12.3615 0.595137 13.4209 1.65449C14.4802 2.71384 15.0754 4.15062 15.0754 5.64877V10.6923C15.0754 11.0457 15.2158 11.3847 15.4657 11.6346C15.7492 11.9181 15.9721 12.0249 16.2838 12.0249C16.5993 12.0249 16.8552 12.2807 16.8552 12.5963C16.8552 12.9119 16.5993 13.1677 16.2838 13.1677H2.56948C2.25388 13.1677 1.99805 12.9119 1.99805 12.5963C1.99805 12.2807 2.25388 12.0249 2.56948 12.0249C2.88113 12.0249 3.10394 11.9181 3.38752 11.6346C3.63743 11.3847 3.77782 11.0457 3.77782 10.6923V5.64877C3.77782 4.15062 4.37296 2.71384 5.43231 1.65449ZM7.42662 15.144C7.42662 14.6706 7.81038 14.2868 8.28376 14.2868H10.5695C11.0429 14.2868 11.4266 14.6706 11.4266 15.144C11.4266 15.6173 11.0429 16.0011 10.5695 16.0011H8.28376C7.81038 16.0011 7.42662 15.6173 7.42662 15.144Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.6703159dc85aab962a7ab089b170d80a.svg";
export { ForwardRef as ReactComponent };